import { Controller } from "stimulus";

const SNOOZE_MS = 2592000000; // 30 days

export default class extends Controller {
  static values = { appname: String, variant: String };

  connect() {
    if (this.dismissedRecently()) return;

    this.element.hidden = false;
    requestAnimationFrame(() => this.element.classList.add("is-visible"));

    try {
      if (!sessionStorage.getItem(this.shownKey())) {
        sessionStorage.setItem(this.shownKey(), "1");
        this.track("app_prompt_shown");
      }
    } catch (e) {}
  }

  dismiss() {
    try {
      localStorage.setItem(this.storageKey(), Date.now().toString());
    } catch (e) {}
    this.element.classList.remove("is-visible");
    this.element.hidden = true;
    this.track("app_prompt_dismissed");
  }

  trackClick() {
    this.track("app_prompt_clicked");
  }

  track(event) {
    if (window.ahoy) {
      window.ahoy.track(event, { appname: this.appnameValue, variant: this.variantValue });
    }
  }

  dismissedRecently() {
    try {
      const ts = parseInt(localStorage.getItem(this.storageKey()), 10);
      return !isNaN(ts) && Date.now() - ts < SNOOZE_MS;
    } catch (e) {
      return false;
    }
  }

  storageKey() {
    return `bp-app-prompt-dismissed-${this.variantValue}`;
  }

  shownKey() {
    return `bp-app-prompt-shown-${this.variantValue}`;
  }
}
